// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"361":"fac97bc644b0aeb1","451":"4c48b14f8a11f226"}[chunkId] + ".js";
};